import React, { useState, useEffect, useCallback, useRef } from 'react';
import DataGrid, {
    Column,
    Paging,
    Pager,
    LoadPanel,
    Scrolling,
    Item as ToolbarItem,
    Toolbar
} from 'devextreme-react/data-grid';
import { useAnteprimaDataSource } from '../../datasources/FilterBuilderDataSource';


interface FilterPreviewProps {
    expression: any;
}

const FilterPreview: React.FC<FilterPreviewProps> = (props) => {
    const dataSource = useAnteprimaDataSource(props.expression);

    const noDataTextFunc = () => {
        if (Array.isArray(props.expression) && props.expression.length === 0)
            return "Tutti gli assistiti"
        else
            return "Nessun assistito con i criteri scelti"
    };
    //<h4>Anteprima risultati</h4>
    return (
        <DataGrid
            dataSource={dataSource}
            // keyExpr="assistitoId"
            showBorders
            height="100%"
            columnAutoWidth
            columnHidingEnabled
            customizeColumns={(columns) => {
                // Nascondiamo le colonne assistitoId e tenantId (indipendentemente dalla capitalizzazione)
                columns.forEach(column => {
                    if (column.dataField) {
                        const fieldName = column.dataField.toLowerCase();
                        if (fieldName === 'tenantid' || fieldName === 'assistitoid') {
                            column.visible = false;
                        }
                    }
                });
            }}
            noDataText={noDataTextFunc()} //  }
        >
            <LoadPanel enabled={true} showPane={true} showIndicator={true} />
            <Scrolling mode="virtual" rowRenderingMode="virtual" />
            <Paging defaultPageSize={10} />
            <Pager
                showPageSizeSelector={true}
                allowedPageSizes={[5, 10, 20]}
                showInfo={true}
            />
            <Toolbar>
                <ToolbarItem
                    location="center"
                    name="caption"
                    render={() => (
                        <div style={{ fontSize: 12, fontWeight: 'bold' }}>
                            Anteprima risultati
                        </div>
                    )}
                />

            </Toolbar>
        </DataGrid>
    );
};

export default React.memo(FilterPreview);
